const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/plans/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import type { PlanRow } from "@/types/api/plan";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/plans/")({
  beforeLoad: args => requirePermission(Permissions.Plans.View, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
export function formatCents(cents: number, currency = "USD"): string {
  try {
    return new Intl.NumberFormat(undefined, {
      style: "currency",
      currency,
      minimumFractionDigits: 2
    }).format(cents / 100);
  } catch {
    return `${(cents / 100).toFixed(2)} ${currency}`;
  }
}